module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_point_01-1e0ee13ef883744b53e08d1b6702a5cc.jpg";